/**
 * Image Modal
 *
 * @note need to consolidate this and videomodal
 */
export default {

    openCtrl: document.querySelectorAll( '[data-js-img-open]' ),
    closeCtrl:  document.querySelectorAll( '[data-js-img-close]' ),

    /**
     * Init
     */
    init: function() {

        if( this.openCtrl.length && this.closeCtrl.length ) {

            for( let i = 0; i < this.openCtrl.length; i++ ) {

                this.openCtrl[i].addEventListener( 'click', event => {

                    event.preventDefault();
                    this.openModal( event );

                } );

            }

            for( let i = 0; i < this.closeCtrl.length; i++ ) {
            
                this.closeCtrl[i].addEventListener( 'click', event => {

                    event.preventDefault();
                    this.closeModal();

                } );

            }

        }

    },

    /**
     * Open
     */
    openModal: function( event ) {
        
        const $target = event.target;
        const $target_container = $target.closest( '[data-js-img-open]' );

        if( $target.hasAttribute( 'data-js-img-close' ) ) {
            return;
        }

        if( 
        $target.hasAttribute( 'data-js-gallery-nav' ) ||
        $target_container.classList.contains( 'is-active' )
        ) {

            this.closeModal();
            return;
        }

        // Find id and element of modal being opened
        const modal_id = $target_container.getAttribute( 'data-js-img-open' );
        const $modal = document.querySelector( '[data-js-img-modal="' + modal_id + '"]' );
    
        // Add active class
        $target_container.classList.add( 'is-active' );
        $modal.classList.add( 'is-active' );

    },

    /**
     * Close
     */
    closeModal: function() {

        const $modal = document.querySelector( '[data-js-img-modal].is-active' );
        const $modal_container = document.querySelector( '[data-js-gallery-single].is-active' );

        // Remove active class of the active modal
        $modal.classList.remove( 'is-active' );
        $modal_container.classList.remove( 'is-active' );


    },

 };


// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/media/image-modal.js